module.exports = __webpack_public_path__ + "img/wallet.c4edd882.svg";